







import { BaseSelect } from '#components/baseSelect';

import { apiProvider } from '../api';

type DataType = {
	PrInvoicePaymentId: number;
	PRIJEMKA_ID: number;
	Text: string;
	PRINVOICE_NO:string;
	PRIJEMKA_NAD: string;
	TOTAL_PAYMENT:number;
	REM_AMOUNT: number;
	X_DODAVATEL_ID: number;
	DODAVATEL_ID:number;
	TOTAL_PAYMENT_WITH_GST: number;
	GST_AMT: number;
	TOTAL_PAYMENT_WITH_VAT: number;
	VAT_AMT: number;
	SUPPLIER: string;
	DMS_INVOICE_NO: string;
	SHIP_TO_WH: string;
	BILL_TO_WH: string;
};

export default BaseSelect.extend({
	name: 'PRInvoice',
	props: {
		labelKey: { type: String, default: 'PrInvoicePaymentId' },
		isClearable: { type: Boolean, default: true },
		filter: { type: Object, default: () => {} },
	},
	data() {
		return {
			storeObject: 'PRInvoice',
			valueFieldName: 'PrInvoicePaymentId',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				osobniCis: null,
				PrijemkaId: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.PRIJEMKA_ID,
				PrijemkaId: data.PRIJEMKA_ID,
				InvoiceNumber: data.PRINVOICE_NO,
				PrijemkaNr: data.PRIJEMKA_NAD,
				TotalPrice: data.TOTAL_PAYMENT,
				OutstandingAmount: data.REM_AMOUNT,
				Supplier: data.X_DODAVATEL_ID,
				DodavatelIdText: data.SUPPLIER,
				DodavatelId: data.DODAVATEL_ID,
				TotalPriceWithGst: data.TOTAL_PAYMENT_WITH_GST,
				GstAmount: data.GST_AMT,
				TotalPriceWithVat: data.TOTAL_PAYMENT_WITH_VAT,
				VatAmount: data.VAT_AMT,
				DodFaktNr: data.DMS_INVOICE_NO,
				ShipToWareHouseName: data.SHIP_TO_WH,
				BillToWareHouseName: data.BILL_TO_WH,
			};
		},
	},
});
